import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mt-3 flex flex-wrap p-3 mb-4 gap-3 border-2 border-gray-100 bg-white border-round-xl relative" }
const _hoisted_2 = { class: "flex-1" }
const _hoisted_3 = { class: "flex-1" }
const _hoisted_4 = { class: "flex-1" }

import { computed, ref } from 'vue';
import { storeToRefs } from 'pinia';
import { useReviewReportStore } from '@/store';
import ReviewReportTrackTotal from './ReviewReportTrackTotal.vue';
import ReviewReportTrackMore from './ReviewReportTrackMore.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'ReviewReportTrack',
  setup(__props) {

const reviewReportStore = useReviewReportStore();
const { track } = storeToRefs(reviewReportStore);

const baseTotals = ref({
  total: 0,
  disciplines: [],
});

const showMore = ref(false);

const showMoreText = computed(() => {
  return showMore.value
    ? {
        icon: 'expand_less',
        text: 'Show Less',
      }
    : {
        icon: 'expand_more',
        text: 'Show More',
      };
});

const isLoading = computed(() => track.value.loading || !Object.keys(track.value.data).length);

const eventsScheduled = computed(() => defineTotals('events_scheduled'));
const eventsCompleted = computed(() => defineTotals('events_completed'));
const evaluationsCompleted = computed(() => defineTotals('evaluations_completed'));

const defineTotals = (key: string) => {
  if (isLoading.value) return baseTotals.value;
  return track.value.data[key];
};

const onShowMore = () => (showMore.value = !showMore.value);

return (_ctx: any,_cache: any) => {
  const _component_AppButton = _resolveComponent("AppButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(ReviewReportTrackTotal, {
        title: "Events Scheduled",
        tooltip: "Sessions, Consultations, and Evaluations scheduled in the selected date range.",
        icon: "calendar_today",
        total: eventsScheduled.value.total,
        color: "blue"
      }, null, 8, ["total"]),
      _createVNode(ReviewReportTrackMore, {
        disciplines: eventsScheduled.value.disciplines,
        color: "blue",
        "show-more": showMore.value
      }, null, 8, ["disciplines", "show-more"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(ReviewReportTrackTotal, {
        title: "Events Completed",
        tooltip: "Sessions, Consultations, and Evaluations completed in the selected date range.",
        icon: "perm_contact_calendar",
        total: eventsCompleted.value.total,
        color: "purple"
      }, null, 8, ["total"]),
      _createVNode(ReviewReportTrackMore, {
        disciplines: eventsCompleted.value.disciplines,
        color: "purple",
        "show-more": showMore.value
      }, null, 8, ["disciplines", "show-more"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(ReviewReportTrackTotal, {
        title: "Evaluations Completed",
        tooltip: "Evaluations where the student has been documented present.",
        icon: "assignment_turned_in",
        total: evaluationsCompleted.value.total,
        color: "pink"
      }, null, 8, ["total"]),
      _createVNode(ReviewReportTrackMore, {
        disciplines: evaluationsCompleted.value.disciplines,
        color: "pink",
        "show-more": showMore.value
      }, null, 8, ["disciplines", "show-more"])
    ]),
    _createVNode(_component_AppButton, {
      type: "text",
      class: "font-normal see-more",
      text: showMoreText.value.text,
      "icon-left": showMoreText.value.icon,
      onClick: onShowMore
    }, null, 8, ["text", "icon-left"])
  ]))
}
}

})